import { useState, useMemo, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Action, sendAULog } from '../fdc/index.mjs';

/**
 * @description common-logs의 sendAULog를 사용하여 AU를 증적합니다. 반드시 react-intersection-observer 를 설치해주세요.
 * @param {object} commonLogInfo memoize 된 service, page, area, code, element, step, customMap, platform 정보
 * @param {string} commonLogInfo.service
 * @param {string} commonLogInfo.page
 * @param {string} commonLogInfo.area
 * @param {string} commonLogInfo.code
 * @param {string} commonLogInfo.element
 * @param {string} commonLogInfo.step
 * @param {object} commonLogInfo.customMap
 * @param {string} commonLogInfo.platform
 * @param {Action} commonLogAction 어떤 액션으로 증적이 되는지 결정합니다. [Action.View, Action.Click]
 * @param {number} inViewAfter 주어진 시간이 지난 후 증적을 시작합니다. (단위: ms)
 * @param {number} threshold 주어진 영역이 얼마나 노출되면 증적할지를 결정합니다 (0~1) 기본값: 0.5
 * @param {boolean} triggerOnce 한번만 트리거할지 결정합니다 (default: true)
 * @param {string} rootMargin 루트의 마진을 설정합니다(e.g. "10px 20px 30px 40px" (top, right, bottom, left))
 * */
const useAULogInView = function (auLogParam) {
  let commonLogAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Action.View;
  let inViewAfter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  let threshold = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;
  let triggerOnce = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  let rootMargin = arguments.length > 5 ? arguments[5] : undefined;
  const [skip, setSkip] = useState(inViewAfter !== 0);
  const [inViewRef, inView] = useInView({
    threshold,
    triggerOnce,
    skip,
    rootMargin
  });
  const stringifyAuLogParam = useMemo(() => JSON.stringify(auLogParam), [auLogParam]);
  useEffect(() => {
    let timerId;
    if (inViewAfter !== 0) {
      timerId = setTimeout(() => {
        setSkip(false);
      }, inViewAfter);
    }
    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [inViewAfter]);
  useEffect(() => {
    if (inView && stringifyAuLogParam) {
      sendAULog(JSON.parse(stringifyAuLogParam), commonLogAction);
    }
  }, [inView, stringifyAuLogParam, commonLogAction]);
  return inViewRef;
};

export { useAULogInView };
